export function applySorting(sortBy, sortDesc, items) {
  if (sortBy.length === 1 && sortDesc.length === 1) {
    items = items.sort((a, b) => {
      const sortA = a[sortBy[0]];
      const sortB = b[sortBy[0]];

      if (sortDesc[0]) {
        if (sortA < sortB) return 1;
        if (sortA > sortB) return -1;
        return 0;
      } else {
        if (sortA < sortB) return -1;
        if (sortA > sortB) return 1;
        return 0;
      }
    })
  }

  return items;
}

export function buildFilters(filters) {
  return filters.filter(e => e.value !== null).map(e => {
    let elem = {...e};
    if (elem.field.indexOf('edges.times') > -1) {
      elem.value = elem.value.map(v => v * 12);
    }
    return elem;
  });
}
//
// export function paths(c, keyTerm, currentPath, t) {
//   for (let i in c) {
//     if (typeof c[i] === 'object') {
//       const nextPath = currentPath ? currentPath + "." + i : i;
//       paths(c[i], keyTerm, nextPath, t);
//     } else if (i.indexOf(keyTerm) !== -1) {
//       t.push(currentPath + '.' + i);
//     }
//   }
//   return t;
// }



// WEBPACK FOOTER //
// ./src/helpers/table.js